import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PatchNotificationLatestNewsApiParams } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const usePatchNotificationLatestNews = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ time, title }: PatchNotificationLatestNewsApiParams) =>
      clientAxios.patch<ApiResponse<unknown>>(
        '/patchNotificationLatestNewsApi/',
        {
          time,
          title,
        }
      ),
    onSettled: async () => {
      return await queryClient.invalidateQueries({
        queryKey: ['notificationLatestNews'],
      });
    },
  });
};

export default usePatchNotificationLatestNews;
